import { createPublicClient, http } from 'viem'
import { bsc } from 'viem/chains'
import Web3 from 'web3'

export const publicClient = createPublicClient({
    chain: bsc,
    transport: http()
})

const PROVIDER_URL_BSC = 'https://bsc-dataseed1.bnbchain.org'
const PROVIDER_URL_SEP = 'https://sepolia.gateway.tenderly.co'
const PROVIDER_URL_BASE = 'https://mainnet.base.org'
const PROVIDER_URL_POL = 'https://polygon.llamarpc.com'
const PROVIDER_URL_ETH = 'https://ethereum-rpc.publicnode.com'
const PROVIDER_URL_TAO = 'https://rpc.taoevm.io'
const PROVIDER_URL_BSCTEST = 'https://bsc-testnet.public.blastapi.io'

export const web3ClientBsc = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_BSC))
export const web3ClientSep = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_SEP))
export const web3Client = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_ETH))
export const baseWeb3Client = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_BASE))
export const polWeb3Client = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_POL))
export const taoWeb3Client = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_TAO))
export const web3ClientBscTest = new Web3(new Web3.providers.HttpProvider(PROVIDER_URL_BSCTEST))

export const web3Clients = {
    56: web3ClientBsc,
    11155111: web3ClientSep,
    1: web3Client,
    137: polWeb3Client,
    8453: baseWeb3Client,
    10321: taoWeb3Client,
    97: web3ClientBscTest
}

export const apiUrl = 'https://api.dogwifhair.fun'

export const imageUrl = apiUrl + '/token/'

export const projectName = "DogWifHair"

export const zeroAddress = "0x0000000000000000000000000000000000000000"

export const BASE_URL = 'https://dogwifhair.fun';

export const bnbPriceApiUrl = `${apiUrl}/api/getBNBPrice`

const BNB_PRICE_CACHE_TTL_MS = 60 * 60 * 1000

let cachedBnbPrice: number | null = null
let bnbPriceFetchedAt: number | null = null
let pendingBnbPriceFetch: Promise<number> | null = null

async function fetchBnbPriceFromApi(): Promise<number> {

    const response = await fetch(bnbPriceApiUrl, { method: 'GET' })
    if (!response.ok) {
        throw new Error('Failed to fetch BNB price')
    }
    const price = await response.json()
    return Number(price)
}

export async function fetchBnbPrice(): Promise<number> {
    const now = Date.now()

    if (
        cachedBnbPrice !== null &&
        bnbPriceFetchedAt !== null &&
        now - bnbPriceFetchedAt < BNB_PRICE_CACHE_TTL_MS
    ) {
        return cachedBnbPrice
    }

    if (pendingBnbPriceFetch) {
        return pendingBnbPriceFetch
    }

    pendingBnbPriceFetch = fetchBnbPriceFromApi()
        .then((price) => {
            cachedBnbPrice = price
            bnbPriceFetchedAt = Date.now()
            pendingBnbPriceFetch = null
            return price
        })
        .catch((error) => {
            pendingBnbPriceFetch = null
            throw error
        })

    return pendingBnbPriceFetch
}

// export const supportedChainIds = [mainnet.id, bsc.id, base.id, 10321]
export const supportedChainIds = [56]

export const chainLogos = {
    1: '/eth.svg',
    56: '/bsc.svg',
    11155111: '/eth.svg',
    137: '/polygon.svg',
    8453: '/base.svg',
    10321: '/tao.png',
    97: '/bsc.svg',
}

export const feeAmounts = {
    1: 0,
    8453: 0,
    56: 0,
    137: 7.13,
    11155111: 0,
    10321: 0.0012,
    97: 0.001,
}

export const initialEth = {
    1: 1.5698,
    8453: 1.5698,
    56: 4.014,
    137: 12558,
    11155111: 1.9,
    10321: 1.9,
    97: 8.53125
}

export const coinNames = {
    1: 'ETH',
    8453: 'ETH',
    56: 'BNB',
    11155111: 'ETH',
    10: 'ETH',
    137: 'POL',
    10321: 'TAO',
    97: 'BNB'
}

export const scanLinks = {
    8453: 'https://basescan.org/',
    1: 'https://etherscan.io/',
    56: 'https://bscscan.com/',
    11155111: 'https://sepolia.etherscan.io/',
    137: 'https://polygonscan.com/',
    10: 'https://optimistic.etherscan.io/',
    10321: 'https://taoscan.org/',
    97: 'https://testnet.bscscan.com/',
}

export const scanApiLinks = {
    8453: 'https://api.basescan.org/api',
    1: 'https://api.etherscan.io/api',
    56: 'https://api.etherscan.io/v2/api',
    11155111: 'https://api-sepolia.etherscan.io/api',
    137: 'https://api.polygonscan.com/api',
    10321: 'https://taoscan.org/api',
    97: 'https://api-testnet.bscscan.com/api'
}

export const apiKeys = {
    56: 'BV2ISWQ7GF881B4CYIRQW77WXGNUJ7F1RV',
    1: '2E446YFS6EPUCJQ84W6GHX626759K121NP',
    11155111: '2E446YFS6EPUCJQ84W6GHX626759K121NP',
    8453: '26VQ3BGAUVDCN9VCNP7PZNG47I8X3S82F2',
    97: 'Y7TXAF2H8KCPY7AXFT7DSTBFUVH794ZCST',
}

export const chainNames = {
    1: 'eth',
    11155111: 'eth',
    8453: 'base',
    56: 'bnb',
    137: 'polygon',
    10321: 'tao',
    97: 'bnb',
}


export default function formatNumber(number) {
    if (number >= 1000000) {
        return (number / 1000000).toLocaleString() + 'M';
    } else if (number >= 1000) {
        return (number / 1000).toLocaleString() + 'K';
    } else {
        return number.toString();
    }
}